import {observer} from "mobx-react"
import React, {Component} from "react"
import {Button, Icon, Input, Segment} from "semantic-ui-react"
import shop from "shop/shop"
import cmsStore from "stores/cmsStore"
import _ from "lodash"
import {Link} from "react-router-dom"
import Price from "components/Price/Price"
import ButtonLove from "components/Button/ButtonLove"
import { Label } from "semantic-ui-react"
import OrderModel   from "shop/OrderModel";
import ImageWithFallback from "components/ImageWithFallback"
import ProductPrice from "components/Product/ProductPrice"

let orders = []
let ordersWithOpenPositions = []
let openPositions = []
let current = 0

@observer
export default class ProductListItem extends Component {

	state = {
		session: shop.session || {}, locations: [], showAddressBook: false, noMoreOrders: false, orderOpen: [], maxOrders: 5, maxOpenOrders: 5
	  }

	  loadSession = ( session ) => {
		this.setState( { noMoreOrders: false } )
	  }
	  componentDidMount() {
		orders = []
		ordersWithOpenPositions = []
		openPositions = []
		current = 0
		shop.events.authentified.add( this.loadSession )
		// this.loadSession()
	  }
	
	render() {
		let {product, index, categoryId = "", to = "/", search = ""} = this.props
		if ( !product ) return <div>NO PRODUCT</div>
		let configByCategory = cmsStore.config.orthoFieldConfigByCategory[String( product.category && product.category.map_id )]

		let isDefaultConfig = false
		if ( !configByCategory ) {
			isDefaultConfig = true
			configByCategory = cmsStore.config.orthoFieldConfigByCategory["DEFAULT"]
		}
		const columnChunks = _.chunk( configByCategory.columns, 1 )
		const inCart = shop.cart.productsById.get( product.map_id ) || product



		return ( 
			<React.Fragment>
				<Segment
					attached={"bottom"}
					className="product db pv4 w-100 ProductListItem relative">
						
					<div className="flex flex-row w-100  items-center justify-between attributes ">
								{/*<ImageWithFallback 		width={45}	fallback={"/image/placeholder.png"}	className="img-responsive"	src={product.img_src_small} />*/}
							<div className={"flex flex-row items-center w-100 justify-left columnChunkContainer"}>
							<Link
								className="pr3 title-segment"
								to={{
									pathname: `${to}product/${product.map_id}/`,
									search
								}}>
								{/*<ImageWithFallback*/}
								{/*	width={45}*/}
								{/*	fallback={"/image/placeholder.png"}*/}
								{/*	className="img-responsive"*/}
								{/*	src={product.img_src_small} />*/}
								
								<div className={""}>
									<div className="pt1">{product.getNotice()}</div>
									<div className={"pt2 pb2 f4 fw7 mw8 w-100 black-90"} key={product.map_id + "desc"}>{product.desc.short_des}</div>
									{!product.map_id.endsWith('090200') && !product.map_id.endsWith('090_200') &&<div className={"f6 black-40 nowrap "}>{product.article_nr}</div>}
									
								</div>
							</Link>
						</div>

		  <table>
			<colgroup>
			<col style={{ width: "50%" }}/>
			  <col style={{ width: "50%" }}/>
			  <col style={{ width: "50%" }}/>
			</colgroup>
			<tbody>
			  <tr>
				<td>
			<ButtonLove list={shop.orderlist.default}
						className="dib mr3"
						elementInActive={<span><Icon name={"large  heart outline"}/></span>}
						elementActive={<span><Icon name={"large  heart"}/></span>}
						product={product}/>
				</td>
				<td className="v-align-top  pb2">
						<div className="">{shop.session && shop.session.shopuser && !shop.session.shopuser.guest  && <span><ProductPrice className={"f2 relative"} product={product} /></span>}
					  </div>
				</td>
				<td className="v-align-top">
				{
				<div style={{border: "none"}} className="">
					<div style={{border: "none"}} className="f4 fw7 ">x {product.quantities[0] ? product.quantities[0].multi : ""}
					</div>
					<div style={{border: "none"}} className="black-30 f6 fw6 ">{product.extras.veextrainfo || translate( "Verkaufseinheit" )}</div>
				</div>}
				</td>
			  </tr>
			  <tr >
				<td>&nbsp;</td>
				<td className="pt2">
				  {product &&
					<Input style={{borderRadius: "35px", height: "40px"}} className="transparent ba b--black-20 bw1 pr1 pl1" type="number" min={Number(product.pinfos.minbuy) != 0 ? Number(product.pinfos.minbuy) : 1} placeholder={product.count || 1} 
					  defaultValue={1} 
					  value={this.state.count}
					  action 
					  onChange={e => {
						this.setState({ count: e.target.value });
					  }}
					  onBlur={e => {
						if (Number(e.target.value) < Number(product.pinfos.minbuy)) {
						shop.toast(translate(`Mindestbestellmenge wurde korrigiert.`), "warning", false, "top");
						e.target.value = Number(product.pinfos.minbuy);
						this.setState({ count: e.target.value });
						  
						}
					  }}>
					  <Button style={{borderRadius: "35px", backgroundColor: "#ffffff", width: "30px"}} icon="minus" onClick={() => {
						let newCount = Math.max((this.state.count ||  1) - 1);
						if(newCount < 1){
						  newCount = 1

						}
						console.log("newCount",newCount)
						this.setState({ count: newCount });
					  }} />
					  <input style={{ width: "50px", height: "40px", textAlign: "center", border: "none"}} onFocus={(e) => e.target.style.outline = "none"} />
					  {/*<Select key={product.map_id} compact options={veOptions} defaultValue={product.quantities && product.quantities[ 0 ].map_desc_id}
						  onChange={( e, data ) => {
							const { value } = data
							const ve = product.quantities.filter( q => q.map_desc_id === value )
							if ( !ve ) return
							product.unit_multi = ve[ 0 ].multi
							product.unit_id = ve[ 0 ].map_desc_id
							console.log( { data, e, value: e.target.value, target: e.target } )
						  }
						  }
					  />*/}

					  <Button style={{borderRadius: "35px", backgroundColor: "#ffffff", width: "30px" }} className="mr2" icon="plus" onClick={() => {
						let newCount = (this.state.count ||  1) + 1;
						console.log("newCount",newCount)
						this.setState({ count: newCount });
					  }} />
				  </Input>}
				</td>
				<td className="tc pt2">
				<Button style={{borderRadius: "35px", backgroundColor: "#ffffff", color: "#369678"}} icon="big cart" onClick={() => {
				let { count } = this.state
				product.count = count
				//console.log("product",product)
				shop.cart.add( product )
				shop.toast( `${product.count} ${product.unit_desc} x ${product.title} ${translate("im Warenkorb")}`, "info", false, "bottom" )
			  }} />
				</td>
			  </tr>
			</tbody>
		  </table>
					</div>

					<div className="dn db-ns pt2 ">
						<div className={"flex flex-row flex-wrap "}>
							
						
							{columnChunks.map( ( tuple, index ) => {
								return <div key={`${index}`} className={""}>
									{tuple
										.filter( ( columnKey, subIndex ) => {
											let fieldValue = product.extras[columnKey]
											switch ( columnKey ) {
												case "ArtikelNrLAG":
												case "Bezeichnung1":
												case "Verpackung":
												case "Bestell-Menge":
												case "Z_Verpackungseinheit_Anzahl":
												case "Preis":
												case "":
													return false

												default:
													if ( !fieldValue ) return null
													return true
											}
										} )
										.map( ( columnKey, subIndex ) => {
											let value
											let fieldValue = product.extras[columnKey]
											const columnDisplayName = fieldValue && fieldValue.text
											const displayValue = fieldValue && fieldValue.value && fieldValue.value.text

											switch ( columnKey ) {
												case "ArtikelNrLAG":
													value = null
													break;
												case "Bezeichnung1":
													value = null
													break;
												case "Verpackung":
													value = null
													break;
												case "Bestell-Menge":
													value = null
													break;
												case "Z_Verpackungseinheit_Anzahl":
													value = null
													break;
												case "Preis":
													value = null
													break;

												case "":
													value = null
													break;

												default:
													if ( !fieldValue ) return null
													value = <div className={"pr3 f6 tuples lh-title ttu pr4-ns"} key={`columnKey-${subIndex}-${index}`}>
														<div title={columnDisplayName} className={"f7 black-80 mw5 truncate"}>{translate(columnDisplayName) || columnKey}</div>
														<div title={displayValue} className={"f6 nowrap mw5 truncate"}>{translate(displayValue) || <span className="red">N.A.</span>}</div>
													</div>
													break;
											}
											return value
										} )}
								</div>
							} )}
							{/*							<div className={"pr3 f6 tuples lh-title ttu pr4-ns"} key={`columnKey-${"VE"}-${index}`}>
								<div title={"VE"} className={"f7 black-60 mw5 truncate "}>VE</div>
								<div title={"VE"} className={"f6 nowrap mw5 truncate"}>{product.smallestQuantity.multi} {translate( "Stück" )}</div>
							</div>

							<div className={"pr3 f6 tuples lh-title ttu pr4-ns"} key={`columnKey-${"DELIVERY"}-${index}`}>
								<div title={"VE"} className={"f7 black-60 mw5 truncate"}>{translate("Lieferzeit")}</div>
								<div title={"VE"} className={"f6 nowrap mw5 truncate"}>{translate(product.getNotice())} </div>
							</div> */}
 
						</div>
					</div>
				</Segment>
			</React.Fragment>
		)
	}
}

function ProductQuantitySimple( {product, inCart = {}} ) {
	const [count, setCount] = React.useState( inCart && inCart.count || 0 )
	const [isDirty, setDirty] = React.useState( false )
	const [isLoading, setLoading] = React.useState( false )
	const same = count === inCart.count
	React.useEffect( () => {
		if ( isDirty ) return // so the input doesnt overwrite user inputted data
		setCount( inCart.count )
	}, [product, inCart] )
	return <div className={"ProductQuantitySimple flex flex-row items-center"}>
		<div className={"pr2"} style={{width: "80px"}}><Input onChange={e => {
			setCount( e.currentTarget.value )
			setDirty( true )
		}} value={count} fluid type={"number"} min={0} /></div>
		<Button
			color={same ? null : "green"}
			loading={isLoading}
			icon={same ? "shopping cart" : "plus"}
			onClick={async () => {
				let n = count

				if ( !n ) {
					n = 1
				} else {
					if ( same ) return
				}

				setLoading( true )
				product.count = n
				shop.cart.add( product )
				setDirty( false )
				await delay( 300 )
				setLoading( false )
			}} />
	</div>
}

function delay( ms ) {
	return new Promise( resolve => setTimeout( resolve, ms ) );
}


// WEBPACK FOOTER //
// ./src/theme/demo2025/components/Product/ProductListItem.js